import { styled } from '@mui/material';

const RoutesSerchResultAlertContainer = styled('div')`
  position: relative;

  ul {
    list-style-type: disc;
    list-style-position: outside;
    padding-left: 20px;
  }

  .MuiTypography-root {
    font-size: 18px;
  }

  .count-title {
    font-size: 16px;
  }

  .MuiAlert-message {
    width: 100%;
  }

  .switch {
    border: none !important;
    margin-top: 10px;
    padding-bottom: 10px;
    color: #383838;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .details-wrap {
    margin-top: 10px;
  }
`;

export default RoutesSerchResultAlertContainer;
